"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../../styles/theme"));
const bankAccountCard_1 = require("../../../components/bankAccountCard/bankAccountCard");
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const labelButton_1 = __importDefault(require("../../../components/labelButton/labelButton"));
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const financialBankAccountSlice_1 = require("./financialBankAccountSlice");
const text_1 = __importStar(require("../../../components/text/text"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const financialDetailsConstants_1 = require("./financialDetailsConstants");
const input_1 = __importStar(require("../../../components/input/input"));
const banks_1 = __importDefault(require("../../../utils/banks"));
const utils_1 = require("../../../utils/utils");
const colors_1 = __importDefault(require("../../../styles/colors"));
const analytics_1 = require("../../../utils/analytics/analytics");
const FinancialBankAccountInformation = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { bankAccounts, canManage } = (0, store_1.useAppSelector)((state) => ({
        bankAccounts: state.home.financial_data ? state.home.financial_data.bank_accounts : [],
        canManage: state.home.financial_data ? state.home.financial_data.manage_bank_accounts : true,
    }));
    const [errors, setErrors] = (0, react_1.useState)();
    const [bankAccountsLocal, setBankAccountsLocal] = (0, react_1.useState)(bankAccounts);
    const [showBankAccountsComponent, setShowBankAccountsComponent] = (0, react_1.useState)(financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_LIST);
    const [selectedBankAccount, setSelectedBankAccount] = (0, react_1.useState)();
    const [bankId, setBankId] = (0, react_1.useState)(selectedBankAccount ? selectedBankAccount.bank_id : '');
    const [bankName, setBankName] = (0, react_1.useState)(selectedBankAccount ? selectedBankAccount.bank_name : '');
    const [bankAccountNumber, setBankAccountNumber] = (0, react_1.useState)(selectedBankAccount ? selectedBankAccount.bank_account_number : '');
    const [bankAccountName, setBankAccountName] = (0, react_1.useState)(selectedBankAccount ? selectedBankAccount.bank_account_name : '');
    const goBackToList = () => {
        setSelectedBankAccount(undefined);
        setShowBankAccountsComponent(financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_LIST);
    };
    // Make bank primary bank api call
    const submitMakePrimary = async (bankAccount_bank_id) => {
        const result = await dispatch((0, financialBankAccountSlice_1.submitFinancialMakePrimaryBankAccount)({ bankAccountId: bankAccount_bank_id }));
        logEventWithExtraProperties('api_call', {
            name: 'make_bank_primary',
            status: 'submitted',
            location: 'screen_FinancialBankAccountInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'make_bank_primary',
                status: 'success',
                location: 'screen_FinancialBankAccountInformation',
            });
            if (result.payload.financial_data && result.payload.financial_data.bank_accounts)
                setBankAccountsLocal(result.payload.financial_data.bank_accounts);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'make_bank_primary',
                status: 'fail',
                location: 'screen_FinancialBankAccountInformation',
            });
            setErrors(result.payload);
        }
    };
    // Delete bank api call
    const submitDelete = async (bankAccount_bank_id) => {
        const result = await dispatch((0, financialBankAccountSlice_1.submitFinancialDeleteBankAccount)({ bankAccountId: bankAccount_bank_id }));
        logEventWithExtraProperties('api_call', {
            name: 'delete_bank_account',
            status: 'submitted',
            location: 'screen_FinancialBankAccountInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'delete_bank_account',
                status: 'success',
                location: 'screen_FinancialBankAccountInformation',
            });
            if (result.payload.financial_data && result.payload.financial_data.bank_accounts)
                setBankAccountsLocal(result.payload.financial_data.bank_accounts);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'delete_bank_account',
                status: 'fail',
                location: 'screen_FinancialBankAccountInformation',
            });
            setErrors(result.payload);
        }
    };
    const submitEditBankAccount = async () => {
        const payload = {
            bank_id: bankId,
            bank_name: bankName,
            bank_account_name: bankAccountName.toString(),
            bank_account_number: bankAccountNumber.toString(),
        };
        // edit bank account
        const result = await dispatch((0, financialBankAccountSlice_1.editBankAccount)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'edit_bank_account',
            status: 'submitted',
            location: 'screen_FinancialBankAccountInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'edit_bank_account',
                status: 'success',
                location: 'screen_FinancialBankAccountInformation',
            });
            setErrors(undefined);
            goBackToList();
            if (result.payload.financial_data && result.payload.financial_data.bank_accounts)
                setBankAccountsLocal(result.payload.financial_data.bank_accounts);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'edit_bank_account',
                status: 'fail',
                location: 'screen_FinancialBankAccountInformation',
            });
            setErrors(result.payload);
        }
    };
    let content;
    if (showBankAccountsComponent === financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_LIST && bankAccountsLocal) {
        content = (react_1.default.createElement(react_native_1.View, null,
            bankAccountsLocal &&
                bankAccountsLocal.map((bankAccount) => (react_1.default.createElement(bankAccountCard_1.BankAccountCard, { key: bankAccount.bank_id, submitMakePrimary: submitMakePrimary, deleteBankAccount: submitDelete, editBankAccount: () => {
                        setShowBankAccountsComponent(financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_DETAILS);
                        setSelectedBankAccount(bankAccount);
                        setBankId(bankAccount.bank_id);
                        setBankName(bankAccount.bank_name);
                        setBankAccountName(bankAccount.bank_account_name);
                        setBankAccountNumber(bankAccount.bank_account_number);
                    }, bankAccount: bankAccount, editable: canManage }))),
            react_1.default.createElement(react_native_1.View, null, canManage && (react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.centerChildHorizontalVertical,
                    styles_1.default.minimumMarginBetweenElementsVertically,
                ] },
                react_1.default.createElement(labelButton_1.default, { title: "ADD ACCOUNT", textColor: theme_1.default.colors.COLOR_PRIMARY, onPress: () => navigation.navigate(screenConstants_1.LOAN_APPLICATION_UPDATE_STATEMENTS_SCREEN), disabled: false, eventName: "add_financial_bank_account" }))))));
    }
    else if (showBankAccountsComponent === financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_DETAILS) {
        content = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Choose Bank", choices: banks_1.default, value: bankName, setValue: setBankName, error: (0, utils_1.getError)('bank_name', errors) }),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Account name", placeholder: "Account name", setValue: setBankAccountName, error: (0, utils_1.getError)('bank_account_name', errors), value: bankAccountName }),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "Account number", placeholder: "Account number", setValue: setBankAccountNumber, error: (0, utils_1.getError)('bank_account_number', errors), value: bankAccountNumber })));
    }
    return (react_1.default.createElement(navContainer_1.default, { isLoading: false, childrenTitle: "Bank account information", errors: errors, specialArrow: true, specialArrowTargetScreen: showBankAccountsComponent === financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_DETAILS ? screenConstants_1.FINANCIAL_BANK_INFORMATION_SCREEN : '', footer: showBankAccountsComponent === financialDetailsConstants_1.BANK_ACCOUNT_COMPONENT_DETAILS &&
            bankAccounts &&
            bankAccounts.length > 0 && (react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitEditBankAccount, disabled: false, eventName: "edit_financial_bank_account" })) },
        canManage ? (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.centerChildHorizontalVertical,
                styles_1.default.minimumMarginBetweenElementsVertically,
            ] },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('profileFinancialBankAccount.add_multiple_bank_accounts')))) : (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.centerChildHorizontalVertical,
                styles_1.default.minimumMarginBetweenElementsVertically,
            ] },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_CRITICAL }, t('profileFinancialBankAccount.banks_cant_be_managed')))),
        content));
};
exports.default = FinancialBankAccountInformation;
